import { Trans } from '@lingui/react/macro'

import Loading from '@/components/ui/Loading'
import Button from '@/components/ui/Button'
import useInfiniteOrders from '../hooks/useInfiniteOrders'
import { RequestTile } from './RequestTile'

export function Requests() {
  const { orders, loading, loadNext, hasMore } = useInfiniteOrders()

  return (
    <section className="flex h-full flex-col gap-5">
      <h1 className="text-heading1 text-text">
        <Trans>Requests</Trans>
      </h1>
      <div className="flex flex-1 flex-col gap-2.5 overflow-y-auto p-5">
        {loading && !orders && (
          <div className="flex h-60 w-full flex-row items-center justify-center">
            <Loading />
          </div>
        )}
        {orders?.map(function (order) {
          return <RequestTile key={order.id} order={order} />
        })}
      </div>
      {hasMore && (
        <div className="flex flex-row justify-center py-2">
          <Button onClick={loadNext} loading={loading}>
            <Trans>Load more</Trans>
          </Button>
        </div>
      )}
    </section>
  )
}
